/**
 * BPOデータ管理クラス
 * 既存のloginDataクラスのパターンを踏襲してBPO関連のデータを管理
 */
class BpoData {
  private readonly BPO_REQUEST_ID_KEY = 'bpo_request_id'
  private readonly BPO_STATUS_KEY = 'bpo_status'
  private readonly BPO_CREATED_AT_KEY = 'bpo_created_at'
  private readonly BPO_VERIFICATION_ID_KEY = 'bpo_verification_id'
  private readonly TRUSTDOCK_VERIFICATION_ID_KEY = 'trustdock_verification_id'
  private readonly BPO_FAILURE_COUNT_KEY = 'bpo_failure_count'

  /**
   * BPO審査リクエストIDを保存
   * @param requestId BPO審査リクエストID
   */
  public setBpoRequestId(requestId: number): void {
    sessionStorage.setItem(this.BPO_REQUEST_ID_KEY, requestId.toString())
  }

  /**
   * BPO審査リクエストIDを取得
   * @returns BPO審査リクエストID（存在しない場合はnull）
   */
  public getBpoRequestId(): number | null {
    const requestId = sessionStorage.getItem(this.BPO_REQUEST_ID_KEY)
    return requestId ? parseInt(requestId, 10) : null
  }

  /**
   * BPO審査リクエストIDを削除
   */
  public clearBpoRequestId(): void {
    sessionStorage.removeItem(this.BPO_REQUEST_ID_KEY)
  }

  /**
   * BPO審査ステータスを保存
   * @param status BPO審査ステータス
   */
  public setBpoStatus(status: string): void {
    sessionStorage.setItem(this.BPO_STATUS_KEY, status)
  }

  /**
   * BPO審査ステータスを取得
   * @returns BPO審査ステータス
   */
  public getBpoStatus(): string | null {
    return sessionStorage.getItem(this.BPO_STATUS_KEY)
  }

  /**
   * BPO審査ステータスを削除
   */
  public clearBpoStatus(): void {
    sessionStorage.removeItem(this.BPO_STATUS_KEY)
  }

  /**
   * 汎用的なデータ保存
   * @param key キー
   * @param value 値
   */
  public setItem(key: string, value: string): void {
    sessionStorage.setItem(key, value)
  }

  /**
   * 汎用的なデータ取得
   * @param key キー
   * @returns 値（存在しない場合はnull）
   */
  public getItem(key: string): string | null {
    return sessionStorage.getItem(key)
  }

  /**
   * 汎用的なデータ削除
   * @param key キー
   */
  public removeItem(key: string): void {
    sessionStorage.removeItem(key)
  }

  /**
   * BPO関連のデータをすべてクリア
   */
  public clearAll(): void {
    this.clearBpoRequestId()
    this.clearBpoStatus()
    this.removeItem(this.BPO_CREATED_AT_KEY)
    this.removeItem(this.BPO_VERIFICATION_ID_KEY)
    this.removeItem(this.TRUSTDOCK_VERIFICATION_ID_KEY)
    this.removeItem(this.BPO_FAILURE_COUNT_KEY)
  }

  /**
   * BPO審査が進行中かどうか
   * @returns 進行中の場合true
   */
  public isBpoInProgress(): boolean {
    const status = this.getBpoStatus()
    return status === 'pending' || status === 'processing'
  }

  /**
   * BPO審査が完了しているかどうか
   * @returns 完了している場合true
   */
  public isBpoCompleted(): boolean {
    const status = this.getBpoStatus()
    return status === 'approved' || status === 'rejected'
  }
}

// シングルトンインスタンスを作成・エクスポート（loginDataパターンを踏襲）
const bpoData = new BpoData()
export default bpoData